<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 09:31:32
 * @fileName     :
 * @Description  : 付款合同台账
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="合同名称" porp="contractName">
            <el-input v-model="formInline.contractName" placeholder="合同名称"></el-input>
          </el-form-item>
          <el-form-item label="供应商联系人" porp="supplierContactPerson">
            <el-input v-model="formInline.supplierContactPerson" placeholder="供应商联系人"></el-input>
          </el-form-item>
          <el-form-item label="供应商" prop="supplierId">
            <el-select clearable v-model="formInline.supplierId" filterable placeholder="请选择供应商">
              <el-option v-for="item in supplierOption" :key="item.id" :label="item.supplierName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序">
            <el-select v-model="formInline.orderBy" placeholder="请选择">
              <el-option key="1" label="创建时间-倒序" value="createTimeDesc"/>
              <el-option key="2" label="到期时间-倒序" value="endTimeDesc"/>
              <el-option key="3" label="到期时间-正序" value="endTimeAsc"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
            <el-button type="primary" @click="exportData('ruleForm')">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
      <!-- <el-button type="success" @click="addItem()">新增</el-button> -->
      <!-- <el-button type="primary">导出</el-button>
      <el-button type="primary">导入</el-button> -->
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
                      @preCurrentChange="childCurrentChange" @preSortChanges="handleSortChange" :loading="loading" :pagination="pagination">
        <template #makePaymentMethodTypeSlot="{ row }">
          <div>
            {{ row.makePaymentMethodType == 1 ? '一次性全款' : '阶段性付款' }}
          </div>
        </template>
        <template #contractStatusSlot="{ row }">
          <div>
            <el-tag :type="formatterState(row.contractStatus, 'contract').type" effect="dark">{{
                formatterState(row.contractStatus, 'contract').text
              }}
            </el-tag>
          </div>
        </template>
        <template #signingTypeSlot="{ row }">
          <div>
            {{ row.signingType == 1 ? '新签' : '续签' }}
          </div>
        </template>
        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">详情</el-button>
          </div>
        </template>
      </tableComponent>
    </div>

    <my-comtract-details ref="myComtractRefs" @initQueryData="queryData" :title="detailsT"
                         :status="preStatus"></my-comtract-details>
  </div>
</template>

<script>
import myComtractDetails from './components/myContractDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import {auditProcessStatus, formatterState} from '@/utils/index'
import {queryPageForLedgerApi, exportForLedger} from '@/api/paymentContract/index'
import {downloadBlobFile} from "@/utils/common";
import { queryBasicSuppliersListApi } from '@/api/basicInfo/index'

export default {
  components: {
    tableComponent,
    myComtractDetails
  },
  data() {
    return {
      loading: false,
      detailsT: '付款合同台账详情',
      formInline: {
        contractName: "",
        supplierContactPerson: "",
        supplierId: "",
        orderBy: "createTimeDesc",
      },

      dataList: [],
      supplierOption: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "58px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "合同名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "180px",
          keyName: "contractName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "项目类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "projectTypeName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 3,
          title: "合同金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "供应商名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "supplierName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "供应商联系人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "80px",
          keyName: "supplierContactPerson", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "我方单位", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "ownerUnitName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "我方负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "ownerChargePersonName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 101,
          title: "到期日期", // 标题名称
          isSort: true, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "endDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 8,
          title: "合同期限（天）", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractDuration", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 9,
          title: "收款方式", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "makePaymentMethodType", // 数据的属性值
          align: "center",
          slotName: "makePaymentMethodTypeSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 10,
          title: "预计利润", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "estimatedProfit", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 11,
          title: "合同状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractStatus", // 数据的属性值
          align: "center",
          slotName: "contractStatusSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 13,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 14,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "145px",
          keyName: "createTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 15,
          title: "操作", // 标题名称
          fixed: "right",
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "", // 数据的属性值
          align: "center",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 20,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    this.getSupplierList()
    this.queryData()
  },
  methods: {
    auditProcessStatus,
    formatterState,
    //查询
    queryData() {
      this.initData()
    },
    //到期日期排序
    handleSortChange(item) {
      if (item.sortState === 'asc') {
        this.formInline.orderBy = 'endTimeAsc'
      } else if (item.sortState === 'desc') {
        this.formInline.orderBy = 'endTimeDesc'
      }
      this.initData()
    },
    //初始化查询
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "20",
        query: {
          params: {
            contractName: "",
            supplierContactPerson: "",
            ...this.formInline
          },
          signingType: "",//签约类型：1 新签 2 续签
          customerId: "",//客户ID
          supplierId: this.formInline.supplierId,//供应商ID
          ownerId: "" //我方单位ID
        },
        ...item
      }
      this.loading = true;
      queryPageForLedgerApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({pageSize: page})
    },
    childCurrentChange(value) {
      this.initData({pageNum: value})
    },
    //重置搜索form
    resetData(formName) {
      this.formInline.contractName = "";
      this.formInline.supplierContactPerson = "";
      this.formInline.supplierId = "";
      this.$nextTick(() => {
        this.initData()
      })
    },
    details(row) {
      this.preStatus = 'view'
      this.detailsT = '付款合同台账详情'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    //获取供应商列表
    getSupplierList() {
      let params = {
        supplierName: ''
      }
      queryBasicSuppliersListApi(params).then(res => {
        if (res.code == 200) {
          this.supplierOption = res.data
        }
      })
    },
    exportData(item = {}) {
      let params = {
        params: {
          contractName: "",
          supplierContactPerson: "",
          ...this.formInline
        },
        signingType: "",//签约类型：1 新签 2 续签
        customerId: "",//客户ID
        supplierId: this.formInline.supplierId,//供应商ID
        ownerId: "", //我方单位ID
        ...item
      }
      exportForLedger(params).then(res => {
        if (res) {
          downloadBlobFile(res, '合同列表.xlsx');
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .operate {
  }
}
</style>
